import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ConfirmationWithIcon } from '@/atoms/Confirmation/Confirmation'
import { Actions as ModalErrorActions } from '@/redux/actions/modal-error.actions'
import { useDispatch } from '@/redux/stores'
import { ApplicationState } from '@/redux/stores/types'

import { useShowModal } from './ModalApi.hooks'

export const ModalErrorHandler = () => {
	const modalError = useSelector((store: ApplicationState) => store.modalError)
	const dispatch = useDispatch()
	const showModal = useShowModal()

	useEffect(() => {
		if (modalError) {
			showModal(({ close }) => (
				<ConfirmationWithIcon
					variant="alert"
					title={modalError.title}
					onConfirm={() => {
						dispatch(ModalErrorActions.clean())
						close()
					}}
				>
					{modalError.message}
				</ConfirmationWithIcon>
			))
		}
	}, [dispatch, modalError, showModal])

	return null
}
